/**
 * @import {BusyController, BusyIfController} from 'nova';
 */
import {portal} from './core/portal.js';
import {publisher} from './core/publisher.js';
import {navigator} from './core/navigator.js';
import {special} from './special/special.js';
import {user} from './user/user.js';
import {Auth} from './user/auth/auth.js';
import {UserSettings} from './user/settings/settings.js';
import {service} from 'nova';
import {make} from './core/service/env.js';

/**
 * @implements {Partial<BusyController<'acng'>>}
 */
@service
class ACNG {
  navigator = navigator;
  publisher = publisher;
  portal = portal;
  user = user;
  settings = make(UserSettings);
  auth = make(Auth);
  special = special;

  /**
   * @deprecated Use {@link user.lang}
   */
  get LANG() {
    DEBUG: console.warn('deprecated `${LANG}` use `${user.lang} plz`');
    return user.lang;
  }

  /**
   * @deprecated Use {@link portal.abbr}
   */
  get PORTAL() {
    DEBUG: console.warn('deprecated `${PORTAL}` use `${portal.abbr} plz`');
    return portal.abbr;
  }

  /**
   * @deprecated Use {@link user.fsk}
   */
  get FSK() {
    DEBUG: console.warn('deprecated `${FSK}` use `${user.fsk} plz`');
    return this.user.fsk;
  }

  /** @type {BusyIfController | undefined} */
  if;
}

DEBUG: ACNG.DEBUG = true;

export {ACNG};
